// gtDossier — download a candidate's dossier as a PDF from anywhere in the app.
// The server builds the document; this fetches it with the signed-in token and
// hands it to the browser as a file. The copy is client-ready: no contact
// details or rate. anonymous: true leaves the name out as well.
import API_BASE from '../config';

function fileName(name, anonymous, fallback) {
  const base = !anonymous && name ? name : fallback || 'candidate';
  const ascii = String(base).normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/[^A-Za-z0-9 -]/g, '').trim().replace(/\s+/g, '-');
  return (ascii || 'candidate') + '-GTCO-dossier.pdf';
}

export async function downloadDossier(getToken, candidateId, { name, refLabel, anonymous = false } = {}) {
  const token = await getToken();
  const res = await fetch(API_BASE + '/api/candidates/' + encodeURIComponent(candidateId) + '/dossier/pdf' + (anonymous ? '?anonymous=1' : ''), {
    headers: { Authorization: 'Bearer ' + token },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || 'Could not make the PDF.');
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName(name, anonymous, refLabel || String(candidateId));
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
